import axiosInstance from "../Utils/axiosInstance";
import { DistrictApi } from "../Constants/api";

export const getDistrictsApi = async (params) => {
  try {
    const searchParams = new URLSearchParams(params);
    let response = await axiosInstance.get(
      `${DistrictApi}?${searchParams.toString()}`
    );

    return response.data;
  } catch (error) {
    return error?.response?.data;
    // throw error; // Re-throw error for further handling if needed
  }
};
